webpackJsonp([114276838955818,60335399758886],{

/***/ 142:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(233);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(142);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 405:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	// import React from 'react';
	// import { Container, Row, Col } from 'react-bs-grid';
	// import { Link } from 'react-router-dom';
	
	exports.default = function () {
	  return null;
	};
	// (
	//   <div className="bg-dark footer">
	//     <Container fluid>
	//       <Row>
	//         <Col sm={12}>
	//           <ul className="list-inline">
	//             <li>
	//               <Link to="/about">About</Link>
	//             </li>
	//             <li>
	//               <a href="http://eepurl.com/RkmNn" target="_blank">Subscribe</a>
	//             </li>
	//           </ul>
	//         </Col>
	//       </Row>
	//     </Container>
	//   </div>
	// );
	

	module.exports = exports["default"];

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(74);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFeather = __webpack_require__(75);
	
	__webpack_require__(406);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'header',
	    { className: 'header' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-12' },
	          _react2.default.createElement(
	            'div',
	            { className: 'header-content' },
	            _react2.default.createElement(
	              'span',
	              { className: 'header-logo' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                _react2.default.createElement('img', { src: '/images/potion.svg', alt: 'Potion' }),
	                _react2.default.createElement(
	                  'strong',
	                  null,
	                  'POTION'
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'hidden-md' },
	                  ' -- Visualization components and utilities'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'nav',
	              { className: 'header-nav' },
	              _react2.default.createElement(
	                'ul',
	                { className: 'header-nav-list' },
	                _react2.default.createElement(
	                  'li',
	                  { className: 'header-nav-list-item' },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/element/' },
	                    'Elements'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'header-nav-list-item' },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/layout/' },
	                    'Layouts'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'header-nav-list-item' },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/extras/' },
	                    'Extras'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'header-nav-list-item' },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/color/' },
	                    'Colors'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'header-nav-list-item' },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/guides/' },
	                    'Guides'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { className: 'header-nav-list-item' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://github.com/finnfiddle/potion', className: 'icon-wrap' },
	                    _react2.default.createElement(_reactFeather.Github, { size: 16 })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _header = __webpack_require__(232);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(231);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	__webpack_require__(405);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Gatsby React Boilerplate'
	    }),
	    _react2.default.createElement(_header2.default, null),
	    children(),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-12f68b07f4641dec5e66.js